import _ from 'underscore';
import {
  getFwdLinkId,
} from '@bingads-webui-campaign/api-errors';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { getEditorialErrorMessage } from '@bingads-webui-campaign/recommendation-core';
import template from './policy-column.pug';

export class PolicyColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, deps }) {
    super({
      name: 'Policy',
      property: 'RejctionPolicy',
      title: i18n.getString('ColumnName_Policy'),
      bodyClasses: ['grid-column-policy'],
      colClasses: ['col-superLongText'],
      sortable: false,
    });
    this.i18n = i18n;
    this.permissions = deps.permissions;
  }

  template({
    value: {
      FlagId,
    },
  }) {
    const { i18n } = this;
    const detail = i18n.getString(`Editorial_RejectionDetail_${FlagId}`) || i18n.getString('Editorial_RejectionDetail_Default');
    const title = getEditorialErrorMessage(FlagId);
    const fwLinkId = getFwdLinkId(FlagId);
    let fwlink = `http://go.microsoft.com/fwlink?LinkId=${fwLinkId}`;
    if (this.permissions && this.permissions.IsDomesticSimplifiedChineseEnabled) {
      fwlink = 'https://about.ads.microsoft.com/zh-cn/pilotpolicy.pdf';
    }

    return template({
      i18n: this.i18n,
      title,
      detail,
      fwlink,
    });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
